export enum TradingContinuePlanTypeEnum {
  BUY = "BUY",
  BALANCE = "BALANCE",
}
